import {
  FormDatePicker,
  FormInput,
  FormSectionHeader,
  FormSelect,
  FormTextarea,
  Loader,
} from "@/components";
import useProjectBasicDtl from "./useProjectBasicDtl";
import { FormProvider } from "react-hook-form";
import {
  ADDRESS,
  DESCRIPTION,
  ESTIMATED_END_DATE,
  ESTIMATED_START_DATE,
  NAME,
  PROJECT_CATEGORY_ID,
  PROJECT_CODE,
  PROJECT_VALUE,
} from "./consts";
import { Button } from "@/components/ui";

const ProjectBasicDtl = () => {
  const {
    form,
    onSubmit,
    requiredFields,
    isAddPending,
    isProjectDataLoading,
    isUpdatePending,
    projectCategoryList,
    isLoadingProjectCategory,
    keys,
    isView,
  } = useProjectBasicDtl();
  const { errors } = form.formState;

  return (
    <>
      {isProjectDataLoading || isLoadingProjectCategory ? (
        <Loader />
      ) : (
        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <div className="bg-white mt-[20px] rounded-lg shadow-sm overflow-hidden px-[30px] py-[25px]">
              <FormSectionHeader>Basic Details</FormSectionHeader>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-[30px]">
                <FormInput
                  name={NAME}
                  control={form.control}
                  label="Project Name"
                  placeholder="Please enter"
                  error={errors[NAME]?.message}
                  isRequired={requiredFields.includes(NAME)}
                  disabled={isView}
                />
                <FormInput
                  name={PROJECT_CODE}
                  control={form.control}
                  label="Project Code/ID"
                  placeholder="Please enter"
                  error={errors[PROJECT_CODE]?.message}
                  isRequired={requiredFields.includes(PROJECT_CODE)}
                  disabled={isView}
                />
                <FormSelect
                  key={keys.projectCategory}
                  name={PROJECT_CATEGORY_ID}
                  control={form.control}
                  label="Project Category"
                  placeholder="Please enter"
                  error={errors[PROJECT_CATEGORY_ID]?.message}
                  isRequired={requiredFields.includes(PROJECT_CATEGORY_ID)}
                  options={(projectCategoryList?.data || [])?.map(
                    (data: any) => ({
                      label: data?.catName,
                      value: data?.projectCategoryId?.toString(),
                    })
                  )}
                  disabled={isView}
                />
                <FormDatePicker
                  name={ESTIMATED_START_DATE}
                  control={form.control}
                  label="Estimated Start Date"
                  placeholder="Please select"
                  error={errors[ESTIMATED_START_DATE]?.message}
                  isRequired={requiredFields.includes(ESTIMATED_START_DATE)}
                  minDate={new Date()}
                  onClear={() => form.setValue(ESTIMATED_START_DATE, "")}
                  disabled={isView}
                />
                <FormDatePicker
                  name={ESTIMATED_END_DATE}
                  control={form.control}
                  label="Estimated End Date"
                  placeholder="Please select"
                  error={errors[ESTIMATED_END_DATE]?.message}
                  isRequired={requiredFields.includes(ESTIMATED_END_DATE)}
                  minDate={form.watch(ESTIMATED_START_DATE)}
                  onClear={() => form.setValue(ESTIMATED_END_DATE, "")}
                  disabled={isView}
                />
                {/* <FormInput
                  name={CLIENT_NAME}
                  control={form.control}
                  label="Client Name"
                  placeholder="Please enter"
                  error={errors[CLIENT_NAME]?.message}
                  isRequired={requiredFields.includes(CLIENT_NAME)}
                  disabled={isView}
                /> */}
                <FormInput
                  name={PROJECT_VALUE}
                  control={form.control}
                  label="Project Value(Budget)"
                  placeholder="Please enter"
                  error={errors[PROJECT_VALUE]?.message}
                  isRequired={requiredFields.includes(PROJECT_VALUE)}
                  variant="integer"
                  startIcon="₹"
                  disabled={isView}
                />
                <div className="col-span-2">
                  <FormInput
                    name={ADDRESS}
                    control={form.control}
                    label="Address"
                    placeholder="Please enter"
                    error={errors[ADDRESS]?.message}
                    isRequired={requiredFields.includes(ADDRESS)}
                    disabled={isView}
                  />
                </div>
                <div className="col-span-2">
                  <FormTextarea
                    name={DESCRIPTION}
                    control={form.control}
                    label="Description"
                    placeholder="Please enter"
                    error={errors[DESCRIPTION]?.message}
                    isRequired={requiredFields.includes(DESCRIPTION)}
                    disabled={isView}
                  />
                </div>
              </div>
            </div>
            {!isView && (
              <div className="flex flex-row justify-end gap-3 py-5">
                <Button
                  type="submit"
                  disabled={isAddPending || isUpdatePending}
                >
                  {isAddPending ||
                    (isUpdatePending && <Loader variant="secondary" />)}
                  Save
                </Button>
              </div>
            )}
          </form>
        </FormProvider>
      )}
    </>
  );
};

export default ProjectBasicDtl;
